import { Button } from "@mui/material"
import noop from "lib/noop"
import { useDarkMode } from "lib/use-dark-mode"

/**
 * A styled Mui button with theme success colors, useful for in success severity alerts.
 *
 * @param {string} text - The text printed inside the button.
 * @param {function} onClick - The function to run when the button is clicked.
 * @returns A pre styled Mui Button.
 */
export function SuccessButton({ text, onClick = noop, sx, ...props }) {
    const isDark = useDarkMode()
    return (
        <Button
            sx={{
                color: isDark ? "success.lighter" : "success.darker",
                borderColor: isDark ? "success.lighter" : "success.darker",
                "&:hover": {
                    borderColor: isDark ? "success.lighter" : "success.darker",
                    backgroundColor: "#00442214",
                },
                ...sx,
            }}
            variant="outlined"
            onClick={onClick}
            {...props}
        >
            {text}
        </Button>
    )
}
